module.exports = __webpack_public_path__ + "img/2recr_regioni.693be1e1.png";